import { UserContext } from 'context/UserContext';
import { useSWRAxiosMutation } from 'hooks/useSWRAxiosMutation';
import { useCallback, useContext } from 'react';
import ReactGA from 'react-ga4';
import useSWRMutation from 'swr/mutation';
import { MantaCareEvent } from './types';
import { MantaCareUser } from 'context/UserContext/types';

export type captureEventOptions = {
    action: string;
    category: string;
    label: string;
};

export const useAnalytics = () => {
    const { user } = useContext(UserContext);
    const { post } = useSWRAxiosMutation();
    const addMantaCareEventRequest = (url: string, { arg: { userId, ...data } }: { arg: MantaCareEvent & { userId: string } }) =>
        post(`${url}/${userId}/events`, data);
    const { trigger } = useSWRMutation(`/users`, addMantaCareEventRequest);

    const captureEvent = useCallback((category: string, action: string, label: string | null, parameters: object = {}) => {
        ReactGA._gaCommandSendEvent(category, action, label, null, parameters);
    }, []);

    const captureMantaCareEvent = useCallback(
        //sometimes due to react state update behaviour user is not available (Ex: right after login), allowing caller to pass user
        async (event: MantaCareEvent, updatedUser?: MantaCareUser) => {
            const userId = user?.id || updatedUser?.id;
            if (!userId) return null;
            return await trigger({ ...event, userId });
        },
        [user]
    );

    return { captureEvent, captureMantaCareEvent };
};
